import PersonageRegister from './PersonageRegister'

export default PersonageRegister
